import { ShipheroReturnStatus } from "@redotech/redo-return-core-common/integrations/returns/shiphero/types";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const SHIPHERO_EXCHANGE_HOLD_DELAY_MAX_SECONDS = 600;

const statusSetting = z.object({
  enabled: z.boolean(),
  status: z.string().trim().min(1).optional(),
});

const freeTextStatuses = z
  .array(z.string().transform((status) => status.trim().toLowerCase()))
  .transform((statuses) => Array.from(new Set(statuses)));

export const shipheroSettings = defineIntegrationSettings({
  fields: {
    customerAccountID: z.string().trim().min(1).nullable(),
    setStatusOnReject: statusSetting,
    setStatusOnReset: statusSetting,
    processItemsThroughRedo: z.boolean(),
    commonBins: z.array(z.string().trim().min(1)),
    processableStatuses: z.array(z.enum(ShipheroReturnStatus)),
    rejectionStatuses: freeTextStatuses,
    flaggedStatuses: freeTextStatuses,
    trustRmaStatusOnly: z.boolean(),
    exchangeHoldDelaySeconds: z
      .number()
      .int()
      .min(0)
      .max(SHIPHERO_EXCHANGE_HOLD_DELAY_MAX_SECONDS)
      .nullable(),
  },
  secrets: {},
  connectOnly: {
    refreshToken: z.string().trim().min(1, "Refresh token is required"),
  },
  computed: { createReturns: z.boolean() },
});

export function shipheroStatusOverlapError(lists: {
  processableStatuses: readonly string[];
  rejectionStatuses: readonly string[];
  flaggedStatuses: readonly string[];
}): string | null {
  const overlaps = (left: readonly string[], right: readonly string[]) =>
    left.some((status) => right.includes(status));
  if (overlaps(lists.rejectionStatuses, lists.processableStatuses)) {
    return "Rejection statuses cannot overlap with processable statuses.";
  }
  if (overlaps(lists.flaggedStatuses, lists.processableStatuses)) {
    return "Flagged statuses cannot overlap with processable statuses.";
  }
  if (overlaps(lists.flaggedStatuses, lists.rejectionStatuses)) {
    return "Flagged statuses cannot overlap with rejection statuses.";
  }
  return null;
}
